import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IAgeBySingleYearOfAge {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalValue?: number | null;
  aged4AndUnder?: number | null;
  underOneYear?: number | null;
  aged1Year?: number | null;
  aged2Years?: number | null;
  aged3Years?: number | null;
  aged4Years?: number | null;
  aged5To9Years?: number | null;
  aged10To15Years?: number | null;
  aged16To19Years?: number | null;
  aged20To24Years?: number | null;
  aged25To34Years?: number | null;
  aged35To49Years?: number | null;
  aged50To64Years?: number | null;
  aged65To74Years?: number | null;
  aged75To84Years?: number | null;
  aged85AndOver?: number | null;
  aged100AndOver?: number | null;
}

export const defaultValue: Readonly<IAgeBySingleYearOfAge> = {};
